module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item"
  }, [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("BACK")]), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "inventory"
  }, [_vm._v("In Stock: " + _vm._s(_vm.product.inventory))]), _vm._v(" "), _c('button', {
    staticClass: "add-button",
    attrs: {
      "disabled": !_vm.product.inventory
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.inventory > 0 ? "Add to cart" : "Out Of Stock"))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6682510"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductPage.vue
// module id = 98
// module chunks = 1